import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';
export default class DeleteAccountRoute extends Route {
  @service dynamicDialogs;

  model() {
    this.dynamicDialogs.openDialog('delete-account-dialog', {
      isCloseBlocked: true,
      additionalDeleteText: __('Additionally, every MeWe Group I own will also be deleted immediately.'),
    });

    return {};
  }
}
